<template>
  <div class="h-screen w-full flex  contain-content overflow-hidden">
    <!-- LADO IZQUIERDO -->
    <div class="w-1/2 login bg-green-700 flex items-center justify-center text-white text-4xl font-bold left-login">
      <!-- Puedes poner aquí una imagen, logo grande, texto, etc -->
      Bienvenido al Sistema
    </div>

    <!-- LADO DERECHO (LOGIN) -->
    <div class="w-1/2 flex items-center justify-center bg-gray-100 right-login">
      <div class="w-full p-8 m-4 md:max-w-md">
        <!-- TODO TU LOGIN IGUAL QUE ANTES -->
        <div class="flex flex-col flex- w-full pl-4 items-center">
          <img width="250" src="@/assets/logo_monitoreo_comunitario_ppd.png" />
        </div>
        <div class="flex flex-col w-full pl-4">
          <form class="w-full max-w-lg" id="signInForm" @submit.prevent="loginSubmit">
            <div class="w-full text-left pb-3 text-gray-900 text-2xl font-bold text-center uppercase">
              Inicio de Sesión
            </div>

            <!-- EMAIL -->
            <div class="mb-4">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2 text-left">Correo electrónico</label>
              <input class="appearance-none block w-full bg-gray-200 border rounded py-2 px-4 focus:outline-none"
                v-model="email" type="text" required/>
            </div>

            <!-- PASSWORD -->
            <div class="mb-4">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2 text-left">Contraseña</label>
              <input class="appearance-none block w-full bg-gray-200 border rounded py-2 px-4 focus:outline-none"
                v-model="password" type="password" required />
            </div>

            <!-- RECORDAR -->
            <label class="flex items-center mb-4">
              <input type="checkbox" v-model="isSavedLogin" class="mr-2" />
              <span class="text-sm">Mantener la sesión iniciada</span>
            </label>

            <!-- BOTÓN -->
            <div class="flex justify-center">
              <BaseButton icon="" class="w-full flex justify-center" variant="info" type="submit">
                Iniciar sesión
              </BaseButton> 
            </div>

            <div class="flex justify-center pt-2">
              <a class="cursor-pointer hover:text-gray-600 text-sm" @click="openResetPasswordModal">
                ¿Olvidaste tu contraseña?
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <reset-password-modal :showing="showResetPasswordModal" @close="showResetPasswordModal = false" />
    <alert-dialog :showing="showingError">...</alert-dialog>
    <BaseAlert
      v-if="alert.visible"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      :dismissible="true"
      :auto-close="false"
      :close-on-backdrop="true"
      @closed="alert.visible = false"
    />
    
  </div>
</template>


<style scoped>
  .login {
    background-color: #005c23;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='384' height='384' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%2300852d' stroke-width='1.5'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%2300b33d'%3E%3Ccircle cx='769' cy='229' r='6'/%3E%3Ccircle cx='539' cy='269' r='6'/%3E%3Ccircle cx='603' cy='493' r='6'/%3E%3Ccircle cx='731' cy='737' r='6'/%3E%3Ccircle cx='520' cy='660' r='6'/%3E%3Ccircle cx='309' cy='538' r='6'/%3E%3Ccircle cx='295' cy='764' r='6'/%3E%3Ccircle cx='40' cy='599' r='6'/%3E%3Ccircle cx='102' cy='382' r='6'/%3E%3Ccircle cx='127' cy='80' r='6'/%3E%3Ccircle cx='370' cy='105' r='6'/%3E%3Ccircle cx='578' cy='42' r='6'/%3E%3Ccircle cx='237' cy='261' r='6'/%3E%3Ccircle cx='390' cy='382' r='6'/%3E%3C/g%3E%3C/svg%3E");
  }

  /*Animaciòn del login*/
  .h-screen {
    overflow: hidden;
  }
  .right-login {
    animation: right-login 1s ease-out forwards;
  }

  .left-login {
    animation: left-login 1s ease-out forwards;
  }

  @keyframes right-login {
    from {
      opacity: 0;
      transform: translateX(100vw);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes left-login {
    from {
      opacity: 0;
      transform: translateX(-100vw);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

</style>

<script>
import { mapState, mapActions } from "vuex";
import ResetPassword from "./ResetPassword";
import AlertDialog from "./AlertDialog";
import BaseAlert from "./atoms/BaseAlert.vue";
import BaseButton from "./atoms/BaseButton.vue";

export default {
  data() {
    return {
      email: "",
      password: "",
      isSavedLogin: false,
      showResetPasswordModal: false,
      showingError: false,
      errorMessage: "",
      alert: {
        visible: false,
        type: '',
        title: '',
        message: '',
      },
    };
  },
  components: {
    "reset-password-modal": ResetPassword,
    AlertDialog,
    BaseAlert,
    BaseButton
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"])
  },
  methods: {
    ...mapActions(["doLogin"]),
    loginSubmit() {
      this.doLogin({
        email: this.email,
        password: this.password,
        isSavedLogin: this.isSavedLogin,
        type: "monitor"
      })
      .catch(error =>{
        this.errorMessage = error;
        //this.showingError = true;
        this.alert = {
          visible: true,
          type: 'error',
          title: 'Ocurrió un error',
          message: error,
        }
      });
    },
    openResetPasswordModal() {
      this.showResetPasswordModal = true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
